/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Container, Row, Col, Card, Button } from "../../components/ui";
import Photo from "components/common/notif-grid-table/photo";

import Author from "components/common/author";
import {
  getPost,
  pageVisit,
  getPostBySlug,
  getComments,
  createComment,
  createLike,
  removeLike,
  createLikeOnPost,
  deleteLikeOnPost,
  getFovuritePosts,
  createFavoritePost,
  removeFavoritePost,
  createPublicAccess,
  getPublicAccessCheck,
  removeComment,
} from "api";
import SuggestedPost from "components/common/post";
import { matchPath } from "react-router-dom";
import { withRouter } from "../../hooks/withRouter";
import LoadingOverlay from "components/common/LoadingOverlay";
import JoditEditor from "jodit-react";
import CommentNotification from "./commentNotification";
import PostData from "views/Post/postData";
import NotificationService from "components/alerts/index";

const getParams = (pathname) => {
  if (!pathname || typeof pathname !== "string") {
    return {};
  }
  let type = pathname.indexOf("video") > 0 ? "video" : "blog";
  const matchBlog = matchPath(`/${type}/:postName`, pathname);
  return (matchBlog && matchBlog.params) || {};
};

const editorConfig = {
  uploader: {
    url: `${process.env.REACT_APP_API_URL}media/image`,
    isSuccess: function (resp) {
      return true;
    },
    process: function (resp) {
      return {
        files: [resp.url],
        path: resp.url,
        baseurl: resp.url,
        error: false,
        message: "",
      };
    },
    defaultHandlerSuccess: function (data) {
      const editor = this.jodit || this;
      editor.selection.insertImage(data.baseurl);
    },
  },
  useSearch: false,
  spellcheck: false,
  showCharsCounter: false,
  showWordsCounter: false,
  showXPathInStatusbar: false,
  buttons: "bold,italic,image,copy,paste",
  placeholder: "",
  readOnly: false,
};

class Post extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      post: null,
      isLoading: true,
      currentComment: "",
      suggestedPosts: [],
      isFavorite: false,
      showShare: false,
      publicAccessVerified: null,
    };
    this.shareRef = React.createRef();
    this.replyEditorRef = React.createRef();
    this.commentEditorRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    this.fetchPost(this.props.match?.params?.postName);
    document.addEventListener("mousedown", this.handleClickOutside);
    // Listen for localStorage changes from other tabs/windows
    window.addEventListener("storage", this.handleStorageChange);

    window.scrollTo(0, 0);
    if (urlParams.get("public-access-verified") !== null) {
      localStorage.setItem(
        "public-access-verified",
        urlParams.get("public-access-verified")
      );
    }
    if (urlParams.get("public-access-email") !== null) {
      localStorage.setItem(
        "public-access-email",
        urlParams.get("public-access-email")
      );
    }
    if (
      localStorage.getItem("public-access-verified") &&
      localStorage.getItem("public-access-verified") === "true"
    ) {
      this.setState({
        publicAccessVerified: true,
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.removeEventListener("storage", this.handleStorageChange);
  };

  handleClickOutside = (event) => {
    if (this.shareRef && !this.shareRef.current.contains(event.target)) {
      this.setState({
        showShare: false,
      });
    }
  };

  handleStorageChange = (e) => {
    // When user data is updated in localStorage (e.g., from admin panel changes)
    if (e.key === "user" && e.newValue) {
      const updatedUser = JSON.parse(e.newValue);
      this.setState({
        user: updatedUser,
      });
    }
  };

  fetchPost = async (slug) => {
    const resp = await getPostBySlug(slug);
    let suggested = [];
    resp.data.suggestedPostIds.slice(0, 3).forEach(async (id) => {
      let post = await getPost(id);
      suggested.push(post.data);
      this.setState({
        suggestedPosts: suggested,
      });
    });
    if (resp.data.suggestedPostIds.length === 0) {
      this.setState({
        suggestedPosts: [],
      });
    }
    let user = null;
    let comments = null;
    let favorites = null;
    if (localStorage.getItem("user") !== null) {
      user = JSON.parse(localStorage.getItem("user"));

      let res = await getComments(resp.data.id);
      comments = res.data;
      favorites = await getFovuritePosts();
      favorites = favorites.data;
      this.setState({
        isFavorite: favorites.filter((f) => f.id === resp.data.id).length > 0,
      });
    }
    this.setState(
      {
        post: resp.data,
        comments: comments,
        user: user,
        favorites: favorites,
        isLoading: false,
      },
      () => {
        setTimeout(() => {
          if (resp.data.embeddedVideo !== null) {
            const videoPlayer = window.Wistia.api("7twlrlom1r");
            if (videoPlayer && resp.data.embeddedVideo) {
              videoPlayer.addToPlaylist(resp.data.embeddedVideo.mediaId);
            }
          }
        }, 1000);
      }
    );
    pageVisit();
  };

  toggleComment = (commentId) => {
    this.state.comments.forEach((p) => {
      if (p.id === commentId) {
        p.replyOpen = p.replyOpen === null ? true : !p.replyOpen;
      }
    });
    this.setState({ comments: this.state.comments });
  };

  componentDidUpdate(prevProps, prevState) {
    const pathname = this.props.location?.pathname;
    const prevPathname = prevProps.location?.pathname;

    if (!pathname || !prevPathname) {
      return; // Exit early if pathname is not available
    }

    const currentParams = getParams(pathname);
    const prevParams = getParams(prevPathname);

    if (
      currentParams.postName &&
      currentParams.postName !== prevParams.postName
    ) {
      this.fetchPost(currentParams.postName);
      window.scrollTo(0, 0);
    }
  }

  reloadComments = async (postId) => {
    let res = await getComments(postId);
    this.setState({
      comments: res.data,
    });
  };

  addComment = async (comment) => {
    // Check if commenting is disabled for the current user
    if (
      this.state.post &&
      this.state.post.currentUserProfile &&
      !this.state.post.currentUserProfile.isCommentingEnabled
    ) {
      NotificationService.error("Commenting disabled. Please contact support.");
      return;
    }

    const data = {
      postId: this.state.post.id,
      parentCommentId: comment,
      content: this.state.currentComment,
    };

    const resp = await createComment(data);
    console.log("Create Comment Response:", resp);

    // Check if response is an error (createComment catches errors and returns them)
    if (resp && resp.status && resp.status >= 400) {
      // Handle error responses - show server error message
      const errorMessage =
        resp?.data?.error || "Failed to post comment. Please try again.";
      NotificationService.error(errorMessage);
      return;
    }

    // Success - add comment to list
    if (resp && resp.data) {
      let comments = this.state.comments;
      comments.push(resp.data);
      this.setState({
        comments: comments,
        currentComment: "",
      });
      document.querySelector(".jodit-wysiwyg").innerHTML = "";
      this.toggleComment(comment);
    }
  };

  isCommentingDisabled = () => {
    const { post } = this.state;
    return post && post.currentUserProfile && !post.currentUserProfile.isCommentingEnabled;
  };

  deleteComment = async (comment) => {
    try {
      if (window.confirm("Do you really want to delete the comment?")) {
        await removeComment(comment && comment.id);
        await this.reloadComments(this.state.post.id);
        alert("Comment deleted");
      }
    } catch (error) {
      alert("Oops, this comment could not be deleted");
    }
  };

  addLike = async (comment) => {
    if (!comment.likes.likedByCurrentUser) {
      await createLike(comment.id);
    } else {
      await removeLike(comment.id);
    }
    const comments = await getComments(this.state.post.id);
    this.setState({
      comments: comments.data,
    });
    this.reloadComments(this.state.post.id);
  };

  setCurrentComment = (text) => {
    this.setState({ currentComment: text });
  };

  setAsFavourite = () => {
    createFavoritePost(this.state.post.id);
    let p = this.state.post;
    p.isFavourite = !this.state.post.isFavourite;
    this.setState({
      post: p,
    });
  };

  removeAsFavorite = () => {
    removeFavoritePost(this.state.post.id);
    let p = this.state.post;
    p.isFavourite = !this.state.post.isFavourite;
    this.setState({
      post: p,
    });
  };

  showShare = () => {
    this.setState({
      showShare: !this.state.showShare,
    });
  };

  likePost = async () => {
    const resp = await createLikeOnPost(this.state.post.id);
    let temp = this.state.post;
    temp.likes.likedByCurrentUser = !temp.likes.likedByCurrentUser;
    if (temp.likes.likedByCurrentUser) {
      temp.likes.total = temp.likes.total + 1;
    } else {
      temp.likes.total = temp.likes.total - 1;
      const resp = await deleteLikeOnPost(this.state.post.id);
    }
    this.setState({
      post: temp,
    });
  };

  isPublicAccessClass = () => {
    return this.state.publicAccessVerified ? "" : "hidden";
  };

  subscribeToPublic = async () => {
    let inviterAffiliateKey = localStorage.getItem("aid");
    let marketingSourceKey = localStorage.getItem("ms");
    let url = new URL(window.location.href);
    const publicAccess = await createPublicAccess(
      this.state.publicAccessEmail,
      this.state.publicAccessName,
      inviterAffiliateKey,
      marketingSourceKey,
      `${url.origin}${url.pathname}?public-access-email=${
        this.state.publicAccessEmail
      }&public-access-verified=${true}`
    );
    if (publicAccess.data.error) {
      this.setState({
        publicAccessError: publicAccess.data.error,
      });
    }
    if (publicAccess.data.alreadyVerified) {
      localStorage.setItem("public-access-email", this.state.publicAccessEmail);
      localStorage.setItem("public-access-verified", true);
      this.setState({
        publicAccessVerified: true,
      });
    }
    if (!publicAccess.data.alreadyVerified) {
      localStorage.setItem("public-access-email", this.state.publicAccessEmail);
      localStorage.setItem("public-access-verified", false);
      this.setState({
        publicAccessVerified: false,
      });
    }
  };

  checkPublicAccessConfirmed = async () => {
    let email = null;
    if (this.state.publicAccessEmail) {
      email = this.state.publicAccessEmail;
    }
    if (localStorage.getItem("public-access-email")) {
      email = this.state.publicAccessEmail;
    }
    const access = await getPublicAccessCheck(email);
    localStorage.setItem("public-access-verified", access.data.verified);
    if (access.data.verified) {
      this.setState({
        publicAccessVerified: true,
      });
    }
  };

  onPublicNameInput = async (event) => {
    this.setState({
      publicAccessName: event.target.value,
    });
  };

  onPublicEmailInput = async (event) => {
    this.setState({
      publicAccessEmail: event.target.value,
    });
  };

  render() {
    const { comments, user } = this.state;
    return (
      <Container fluid className="main-content-container">
        <LoadingOverlay
          active={this.state.isLoading}
          spinner
          text="Loading your content..."
        >
          <Row>
            <Col lg={{ size: 10, offset: 1 }} md="12">
              <Card small className="mb-5 mt-5 p-5 post-overview">
                {this.state.post &&
                  this.state.post.author.isFeaturedContributor && (
                    <h4 class="ribbon">Featured Contributor</h4>
                  )}
                <PostData
                  post={this.state.post}
                  user={this.state.user}
                  showShare={this.state.showShare}
                  οnShare={this.showShare}
                  removeAsFavorite={this.removeAsFavorite}
                  setAsFavourite={this.setAsFavourite}
                  likePost={this.likePost}
                  shareRef={this.shareRef}
                  publicAccessVerified={this.state.publicAccessVerified}
                  publicAccessError={this.state.publicAccessError}
                  checkPublicAccessConfirmed={this.checkPublicAccessConfirmed}
                  subscribeToPublic={this.subscribeToPublic}
                  publicAccessName={this.state.publicAccessName}
                  publicAccessEmail={this.state.publicAccessEmail}
                  isPublicAccessClass={this.isPublicAccessClass}
                  onPublicEmailInput={this.onPublicEmailInput}
                  onPublicNameInput={this.onPublicNameInput}
                ></PostData>

                {this.state.suggestedPosts.length > 0 && (
                  <div className="suggested-posts">
                    <Row>
                      <Col lg="12">
                        <span className="title">Suggested Posts</span>
                      </Col>
                      {this.state.suggestedPosts.map((post, idx) => (
                        <SuggestedPost
                          SuggestedPost={true}
                          key={idx}
                          col="4"
                          post={post}
                        />
                      ))}
                    </Row>
                  </div>
                )}
                {!user && <div className="add-comment"></div>}
                {user && this.state.post.content && (
                  <div className="add-comment">
                    <span className="comments-amount">
                      {!!comments && <div>{comments.length} Comments</div>}
                    </span>
                    <div className="comments">
                      {!!comments &&
                        comments
                          .filter((c) => c.parentCommentId === null)
                          .map((comment, id) => (
                            <div
                              style={{
                                padding:
                                  comments.filter(
                                    (c) => c.parentCommentId === comment.id
                                  ).length === 0
                                    ? "32px 24px 0px 24px"
                                    : {},
                              }}
                              className="comment-item"
                              id={comment.id}
                            >
                              <div className="comment-item-avatar-area">
                                <Author
                                  url={"#"}
                                  name={comment.user.name}
                                  date={comment.createdAt}
                                  avatar={comment.user.avatar.small}
                                  badgeImg={
                                    comment.user.roleId === 3
                                      ? require("../../images/bitcoin-live/verified.png")
                                      : undefined
                                  }
                                  badgeImgClass={
                                    comment.user.roleId === 3
                                      ? "publisher-badge-img"
                                      : undefined
                                  }
                                  nameStyle={
                                    comment.user.roleId === 3
                                      ? {
                                          fontWeight: "bold",
                                          fontSize: "14px",
                                          textShadow:
                                            "0 1px 4px rgba(255,255,255,0.3), 0 1px 4px rgba(0,0,0,0.15)",
                                        }
                                      : undefined
                                  }
                                />
                                {(user &&
                                  (user.userRoleId === 1 ||
                                    user.userRoleId === 3)) ||
                                (user &&
                                  comment.user &&
                                  user.id === comment.user.id) ? (
                                  <i
                                    onClick={() => this.deleteComment(comment)}
                                    className="material-icons"
                                  >
                                    delete_forever
                                  </i>
                                ) : null}
                              </div>
                              <div className="comment-body">
                                <p
                                  className="comment-text"
                                  dangerouslySetInnerHTML={{
                                    __html: comment.content,
                                  }}
                                ></p>
                                <div className="likes">
                                  <i
                                    className={
                                      comment.likes.likedByCurrentUser
                                        ? "material-icons thumb_up selected"
                                        : "material-icons thumb_up"
                                    }
                                    onClick={() => this.addLike(comment)}
                                  >
                                    thumb_up
                                  </i>
                                  {comment.likes.likedByCurrentUser && (
                                    <span>
                                      You and {comment.likes.total - 1} others
                                      like this
                                    </span>
                                  )}
                                  {!comment.likes.likedByCurrentUser && (
                                    <span>{comment.likes.total} Likes</span>
                                  )}
                                  <div
                                    style={{
                                      display: "flex",
                                      cursor: this.isCommentingDisabled()
                                        ? "not-allowed"
                                        : "pointer",
                                      marginLeft: 25,
                                      opacity: this.isCommentingDisabled()
                                        ? 0.5
                                        : 1,
                                    }}
                                    onClick={() => {
                                      if (!this.isCommentingDisabled()) {
                                        this.toggleComment(comment.id);
                                      }
                                    }}
                                  >
                                    <span
                                      style={{ fontSize: 27 }}
                                      class="material-icons"
                                    >
                                      reply
                                    </span>
                                    <span
                                      style={{ margin: "4px 10px 4px 5px" }}
                                    >
                                      Reply
                                    </span>
                                  </div>
                                  {window.screen.width > 500 && (
                                    <CommentNotification
                                      comment={comment}
                                      commentId={comment && comment.id}
                                      currentUser={user}
                                    ></CommentNotification>
                                  )}
                                </div>
                                {window.screen.width < 500 && (
                                  <CommentNotification
                                    comment={comment}
                                    commentId={comment && comment.id}
                                    currentUser={user}
                                  ></CommentNotification>
                                )}
                              </div>
                              <br />
                              {comment.replyOpen && (
                                <React.Fragment>
                                  <div className="area">
                                    <Photo
                                      avatar={!!user ? user.avatar.small : null}
                                      name={!!user ? user.name : ""}
                                    />
                                    <div className="form-group">
                                      <JoditEditor
                                        id="addComment"
                                        ref={this.replyEditorRef}
                                        value={this.state.content}
                                        config={editorConfig}
                                        tabIndex={1}
                                        onBlur={(newContent) =>
                                          this.setCurrentComment(newContent)
                                        }
                                      ></JoditEditor>
                                    </div>
                                  </div>
                                  <div className="buttons text-right">
                                    <Button
                                      style={{ marginBottom: 10 }}
                                      theme="accent"
                                      className="btn-orange"
                                      disabled={this.isCommentingDisabled()}
                                      title={
                                        this.isCommentingDisabled()
                                          ? "Commenting disabled for your account"
                                          : ""
                                      }
                                      onClick={() =>
                                        this.addComment(comment.id)
                                      }
                                    >
                                      Add comment
                                    </Button>
                                  </div>
                                </React.Fragment>
                              )}
                              {!!comments &&
                                comments
                                  .filter(
                                    (c) => c.parentCommentId === comment.id
                                  )
                                  .map((comment, id) => (
                                    <div
                                      className="replyComments"
                                      id={comment.id}
                                    >
                                      <div className="comment-item-avatar-area">
                                        <Author
                                          url={"#"}
                                          name={comment.user.name}
                                          date={comment.createdAt}
                                          avatar={comment.user.avatar.small}
                                          badgeImg={
                                            comment.user.roleId === 3
                                              ? require("../../images/bitcoin-live/verified.png")
                                              : undefined
                                          }
                                          badgeImgClass={
                                            comment.user.roleId === 3
                                              ? "publisher-badge-img"
                                              : undefined
                                          }
                                          nameStyle={
                                            comment.user.roleId === 3
                                              ? {
                                                  fontWeight: "bold",
                                                  fontSize: "14px",
                                                  textShadow:
                                                    "0 1px 4px rgba(255,255,255,0.3), 0 1px 4px rgba(0,0,0,0.15)",
                                                }
                                              : undefined
                                          }
                                        />
                                        {(user &&
                                          (user.userRoleId === 1 ||
                                            user.userRoleId === 3)) ||
                                        (user &&
                                          comment.user &&
                                          user.id === comment.user.id) ? (
                                          <i
                                            onClick={() =>
                                              this.deleteComment(comment)
                                            }
                                            className="material-icons"
                                          >
                                            delete_forever
                                          </i>
                                        ) : null}
                                      </div>
                                      <div className="comment-body">
                                        <p
                                          className="comment-text"
                                          dangerouslySetInnerHTML={{
                                            __html: comment.content,
                                          }}
                                        ></p>
                                        <div className="likes">
                                          <i
                                            className={
                                              comment.likes.likedByCurrentUser
                                                ? "material-icons thumb_up selected"
                                                : "material-icons thumb_up"
                                            }
                                            onClick={() =>
                                              this.addLike(comment)
                                            }
                                          >
                                            thumb_up
                                          </i>
                                          {comment.likes.likedByCurrentUser && (
                                            <span>
                                              You and {comment.likes.total - 1}{" "}
                                              others like this
                                            </span>
                                          )}
                                          {!comment.likes
                                            .likedByCurrentUser && (
                                            <span>
                                              {comment.likes.total} Likes
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                            </div>
                          ))}
                      <div className="area" style={{ marginTop: 45 }}>
                        <Photo
                          avatar={!!user ? user.avatar.small : null}
                          name={!!user ? user.name : ""}
                        />
                        <div className="form-group">
                          <JoditEditor
                            id="addComment"
                            ref={this.commentEditorRef}
                            value={this.state.content}
                            config={editorConfig}
                            tabIndex={1}
                            onBlur={(newContent) =>
                              this.setCurrentComment(newContent)
                            }
                          ></JoditEditor>
                        </div>
                      </div>
                      <div className="buttons text-right">
                        <Button
                          theme="accent"
                          className="btn-orange"
                          disabled={this.isCommentingDisabled()}
                          title={
                            this.isCommentingDisabled()
                              ? "Commenting disabled for your account"
                              : ""
                          }
                          onClick={() => this.addComment(null)}
                        >
                          ADD COMMENT
                        </Button>
                      </div>
                    </div>
                    {this.isCommentingDisabled() && (
                      <div
                        style={{
                          padding: "24px",
                          marginTop: "24px",
                          borderRadius: "8px",
                          background:
                            "linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%)",
                          border: "1px solid #fdd9d6",
                          boxShadow: "0 2px 8px rgba(220, 38, 38, 0.08)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "5px",
                            marginBottom: "12px",
                          }}
                        >
                          <i
                            className="material-icons"
                            style={{
                              fontSize: "18px",
                              color: "#dc2626",
                              fontWeight: "bold",
                              top: 0,
                            }}
                          >
                            lock
                          </i>
                          <span
                            style={{
                              color: "#7f1d1d",
                              fontSize: "16px",
                              fontWeight: "500",
                              letterSpacing: "0.3px",
                            }}
                          >
                            Commenting is disabled for your account
                          </span>
                        </div>
                        <p
                          style={{
                            color: "#991b1b",
                            fontSize: "13px",
                            margin: "0",
                            fontWeight: "400",
                            letterSpacing: "0.2px",
                            textAlign: "center",
                          }}
                        >
                          Your commenting ability has been temporarily
                          restricted.{" "}
                          <span style={{ fontWeight: "600" }}>
                            Please contact support
                          </span>{" "}
                          for assistance or to appeal this restriction.
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        </LoadingOverlay>
      </Container>
    );
  }
}

export default withRouter(Post);
